import React from 'react';
import FormHookInput from "../../air/airBooking/components/formHookInput";

const BlackListItem = ({prefix,formController,removeItem}) => {
  const {register,
    formState:{errors}} = formController
  return (
    <div className={'d-flex gap-2 align-items-center p-3'}>
      <div className={'w-50'}>
        <FormHookInput
          register={register(`${prefix}.lastName`, {required: true})}
          label={'Фамилия'}
          errors={errors}
        />
      </div>
      <div className={'w-50'}>
        <FormHookInput
          register={register(`${prefix}.firstName`)}
          label={'Имя'}
          errors={errors}
        />
      </div>
      <i className={"fa fa-trash text-danger pointer"} onClick={removeItem}/>

    </div>
  );
};

export default BlackListItem;
